import { Suspense, useContext, lazy, useEffect, useState } from 'react'
import { isUserLoggedIn } from '@utils'
import { useLayout } from '@hooks/useLayout'
import { AbilityContext } from '@src/utility/context/Can'
import { useRouterTransition } from '@hooks/useRouterTransition'

import LayoutWrapper from '@layouts/components/layout-wrapper'

import { BrowserRouter as AppRouter, Route, Switch, Redirect } from 'react-router-dom'
import { DefaultRoute, Routes } from './routes'

import BlankLayout from '@layouts/BlankLayout'
import VerticalLayout from '@src/layouts/VerticalLayout'

const Router = () => {
  const [layout, setLayout] = useLayout()
  const [transition, setTransition] = useRouterTransition()

  const ability = useContext(AbilityContext)

  const DefaultLayout = 'VerticalLayout'

  const Layouts = { BlankLayout, VerticalLayout }

  const currentActiveItem = null
  const LayoutRoutesAndPaths = layout => {
    const LayoutRoutes = []
    const LayoutPaths = []

    if (Routes) {
      Routes.filter(route => {
        if (route.layout === layout || (route.layout === undefined && DefaultLayout === layout)) {
          LayoutRoutes.push(route)
          LayoutPaths.push(route.path)
        }
      })
    }

    return { LayoutRoutes, LayoutPaths }
  }

  const Error_403 = lazy(() => import('@src/views/errors/403'))

  const Error_404 = lazy(() => import('@src/views/errors/404'))

  const FinalRoute = props => {
    const route = props.route
    let action, resource
    if (route.meta) {
      action = route.meta.action ? route.meta.action : null
      resource = route.meta.resource ? route.meta.resource : null
    }

    if (
      ((!isUserLoggedIn() && route.meta === undefined) ||
      (!isUserLoggedIn() && route.meta && !route.meta.authRoute && !route.meta.publicRoute))
      && route.path !== '/leitura/:livroId/:type'
    ) return <Redirect to='/login' />
    
    else if (route.meta && route.meta.authRoute && isUserLoggedIn()) return <Redirect to='/' />
    else return <route.component {...props} />
  }

  const ResolveRoutes = () => {
    return Object.keys(Layouts).map((layout, index) => {
      const LayoutTag = Layouts[layout]
      const { LayoutRoutes, LayoutPaths } = LayoutRoutesAndPaths(layout)

      const routerProps = {}

      return (
        <Route path={LayoutPaths} key={index}>
          <LayoutTag
            routerProps={routerProps}
            layout={layout}
            setLayout={setLayout}
            transition={transition}
            setTransition={setTransition}
            currentActiveItem={currentActiveItem}
          >
            <Switch>
              {LayoutRoutes.map(route => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    exact={route.exact === true}
                    render={props => {
                      Object.assign(routerProps, {
                        ...props,
                        meta: route.meta
                      })

                      return (
                        <Suspense fallback={null}>
                          <LayoutWrapper
                            layout={DefaultLayout}
                            transition={transition}
                            setTransition={setTransition}
                            {...(route.appLayout ? { appLayout: route.appLayout } : {})}
                            {...(route.meta ? { routeMeta: route.meta } : {})}
                            {...(route.className ? { wrapperClass: route.className } : {})}
                          >
                            <FinalRoute route={route} {...props} />
                          </LayoutWrapper>
                        </Suspense>
                      )
                    }}
                  />
                )
              })}
            </Switch>
          </LayoutTag>
        </Route>
      )
    })
  }

  return (
    <AppRouter basename={process.env.REACT_APP_BASENAME}>
      <Switch>
        {/* If user is logged in Redirect user to DefaultRoute else to login */}
        <Route
          exact
          path='/'
          render={() => {
            return isUserLoggedIn() ? <Redirect to={DefaultRoute} /> : <Redirect to='/login' />
          }}
        />
        {/* Not Auth Route */}
        <Route
          exact
          path='/nao-autorizado'
          render={props => (
            <Layouts.BlankLayout>
              <NotAuthorized />
            </Layouts.BlankLayout>
          )}
        />
        {ResolveRoutes()}

        {/* NotFound Error page */}
        <Route path='*' component={Error_404} />
      </Switch>
    </AppRouter>
  )
}

export default Router
